import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { SessionService } from './../_shared/session/session.service';
import { DocumentoGlobal } from './../_shared/documento/documento-global';
import { CandidatoService } from '../_shared/candidato/candidato.service';
import { DocumentoService } from './../_shared/documento/documento.service';

@Component({
  selector: 'app-documentos-complementares',
  templateUrl: './documentos-complementares.component.html',
  styleUrls: ['./documentos-complementares.component.css']
})
export class DocumentosComplementaresComponent implements OnInit {

  public mostrarUpload = false;
  public documentos = new Array<any>();

  constructor(private router: Router,
    private DocumentoService: DocumentoService,
    private SessionService: SessionService,
    public DocumentoGlobal: DocumentoGlobal,
    public CandidatoService: CandidatoService) {

    this.DocumentoGlobal.adicionaDocumentoEmitter.subscribe(documento => this.adicionaDocumento(documento));

    this.DocumentoGlobal.removeDocumentoEmitter.subscribe(documento => this.removeDocumento(documento));

    this.DocumentoGlobal.imagemDocumentoEmitter.subscribe(documento => this.adicionaImagem(documento));

    this.DocumentoGlobal.tipoDocumentoEmitter.subscribe(documento => this.adicionaTipo(documento));
  }

  adicionaDocumento(adicionaDocumento) {
    this.documentos = this.DocumentoGlobal.adicionaDocumentoGlobal(this.documentos, adicionaDocumento);
  }

  removeDocumento(removerDocumento) {
    this.documentos = this.DocumentoGlobal.removeDocumentoGlobal(this.documentos, removerDocumento);
  }

  adicionaImagem(documentoImagem) {
    this.documentos = this.DocumentoGlobal.adicionaImagemGlobal(this.documentos, documentoImagem);
  }

  adicionaTipo(documentoTipo) {
    this.documentos = this.DocumentoGlobal.adicionaTipoGlobal(this.documentos, documentoTipo);
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    if (!this.CandidatoService.getDocumentosCandidato()) {
      this.CandidatoService.getTodosDocumentos()
        .subscribe(documentosCandidato => this.setDocumentos(documentosCandidato), err => err);
    } else {
      this.setDocumentos(this.CandidatoService.getDocumentosCandidato());
    }

  }

  setDocumentos(documentosCandidato) {

    if (documentosCandidato.length === 3) {
      this.proximoDocumentosComplementares(documentosCandidato);
    }

    documentosCandidato.forEach(documento => {
      if (!this.getTipoObrigatorios(documento.TipDocCod)) {
        this.documentos.push(documento);
      }
    });

    this.documentos.forEach(documento => {
      documento.DocCaminho.forEach(caminho => {
        if (caminho.PrcTipEnt === 'U' || caminho.PrcTipEnt == 'C') {
          documento.temDocPostado = true;
        }
        if (!caminho.VPesDocIdArquivo) {
          caminho.VPesDocIdArquivo = Math.floor(Math.random() * 50) + 1;
        }
      });
    });
  }

  anterior() {
    if (this.mostrarUpload === false) {
      this.passoAnterior();
    } else {
      this.mostrarUpload = false;
    }
  }

  proximoUpload() {
    if (this.documentos.some(documento => documento.temDocPostado)) {
      this.mostrarUpload = true;
    } else {
      this.proximo();
    }
  }

  passoAnterior() {
    this.router.navigate(['/historico-escolar']);
  }

  proximo() {
    this.CandidatoService.getTodosDocumentos()
      .subscribe(documentosCandidato => this.proximoDocumentosComplementares(documentosCandidato), err => err);
  }

  proximoDocumentosComplementares(documentosCandidato) {

    this.validaDocumentosObrigatorios(documentosCandidato);

    this.updadeDocumentosComplementares();

    this.router.navigate(['/mensagem-final']);

  }

  validaDocumentosObrigatorios(documentosCandidato) {
    let documentosValidos = true;

    if (documentosCandidato) {
      documentosCandidato.forEach(documento => {
        if (this.getTipoObrigatorios(documento.TipDocCod)) {

          documento.DocCaminho.forEach(caminho => {
            if (caminho.PrcTipEnt === 'U' || caminho.PrcTipEnt === 'C') {
              documentosValidos = false;
            }
          });
        }
      });
    }

    if (documentosValidos) {
      this.SessionService.setValor('final', 'true');
    } else {
      this.SessionService.setValor('final', 'false');
    }
  }


  updadeDocumentosComplementares() {
    const documentosUpload = [];

    this.documentos.forEach(documento => {
      if (documento.temDocPostado) {
        documentosUpload.push(documento);
      }
    });

    if (documentosUpload.length >= 1) {
      this.DocumentoService.uploadDocumentos(documentosUpload);
    }
  }

  getTipoObrigatorios(TipDocCod) {
    return TipDocCod == this.DocumentoGlobal.getTipoRg()
      || TipDocCod == this.DocumentoGlobal.getTipoDiploma()
      || TipDocCod == this.DocumentoGlobal.getTipoHistorico();
  }



}



// WEBPACK FOOTER //
// ./src/app/documentos-complementares/documentos-complementares.component.ts